export default __webpack_public_path__ + "static/media/brand_img01.5704a144.png";